module.exports = __webpack_public_path__ + "static/media/learn.23e865a1.png";